import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

import logo from "../assets/images/gtech-logo-final-04-removebg-preview.png";

const ListIconData = [
  {
    iconClass: "mdi mdi-facebook",
    link: "#",
  },
  {
    iconClass: "mdi mdi-instagram",
    link: "#",
  },
  {
    iconClass: "mdi mdi-whatsapp",
    link: "#",
  },
];

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="bg-footer">
        <Container>
          <Row className="align-items-center">
            <Col lg={4}>
              <div className="mt-4">
                <Link to="/">
                  <img src={logo} alt="Gtech Solar" height="40" />
                </Link>
                <p className="text-white-50 mt-3 pt-2 mb-0">
                  Desde 2018 transformando o sol em economia para você.
                  Especialistas em energia solar para residências, comércios e indústrias.
                </p>
                <div className="mt-4">
                  <ul className="list-inline footer-social">
                    {ListIconData.map((item, key) => (
                      <li className="list-inline-item" key={key}>
                        <a href={item.link} target="_blank" rel="noreferrer">
                          <i className={item.iconClass}></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div className="mt-4">
                <h6 className="text-white text-uppercase fs-16">Links Rápidos</h6>
                <ul className="list-unstyled footer-link mt-3 mb-0">
                  <li><a href="#home">Início</a></li>
                  <li><a href="#quem-somos">Quem Somos</a></li>
                  <li><a href="#servicos">Serviços</a></li>
                  <li><a href="#contato">Contato</a></li>
                </ul>
              </div>
            </Col>

            <Col lg={4}>
              <div className="mt-4">
                <h6 className="text-white text-uppercase fs-16">Contato</h6>
                <div className="mt-3 mb-0">
                  <div className="d-flex mb-2">
                    <i className="mdi mdi-phone text-white-50"></i>
                    <p className="text-white-50 ps-3 mb-0">
                      (43) 3348-0000
                    </p>
                  </div>
                  <div className="d-flex mb-2">
                    <i className="mdi mdi-email text-white-50"></i>
                    <p className="text-white-50 ps-3 mb-0">
                      contato@gtechsolar.com.br
                    </p>
                  </div>
                  <div className="d-flex">
                    <i className="mdi mdi-clock text-white-50"></i>
                    <p className="text-white-50 ps-3 mb-0">
                      Seg-Sex: 08:00 - 18:00
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
}

export default Footer;
